import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MusicOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"music_off"}/>
}
